enum MemberStatesEnums {
    REGULATION_EC_NO_1049_2001 = 'REGULATION_EC_NO_1049_2001',
    SINCERE_COOPERATION = 'SINCERE_COOPERATION',
}

namespace MemberStatesEnums {

    type AdditionalFields = { resourceKey: string };
    export type Entry = { enumKey: string } & AdditionalFields;

    const fieldsMap: Map<MemberStatesEnums, AdditionalFields> = new Map(
        [
            [MemberStatesEnums.REGULATION_EC_NO_1049_2001, {resourceKey: 'easeportal.common.REGULATION-EC'}],
            [MemberStatesEnums.SINCERE_COOPERATION, {resourceKey: 'easeportal.common.SINCERE-COOPERATION'}],
        ]);

    // Note: Without Array.from() the 'let ... of' loops cause: "type 'IterableIterator<>'
    // is not an array type or a string type" error when --downlevelIteration is not set
    // In any case here we do not stop to entries() IterableIterator.
    // We further map from [key: {resourceKey: }] to {enumKey: , resourceKey:}
    export const entries: Array<Entry> = Array.from(fieldsMap.entries()).map((v) => ({enumKey: v[0], ...v[1]}));
    // values of the enumerator
    export const values: Array<MemberStatesEnums> = Array.from(fieldsMap.keys());

    export const resourceKey = (e: MemberStatesEnums): string => {
        const x = fieldsMap.get(e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        }// strictNullChecks require this
        return x.resourceKey;
    };

}

export { MemberStatesEnums };
